import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Box, Button, Box as Container } from '@node-space/ui-components'
import { PathNames } from 'constants/General'
import {
  AmplitudeEvent,
  AmplitudeEventAction,
  AmplitudeEventCategory,
} from 'utils/amplitude/amplitudeEvents'
import { isProduction, isSandbox, isTest } from 'utils/environment'
import { Amp } from 'utils/tracker'

export interface HeaderCTAProps {
  helpText?: string
  buttonText: string
  buttonUrl: string
  externalLink?: boolean
}

export const HeaderCTA = ({ helpText, buttonText, buttonUrl, externalLink }: HeaderCTAProps) => {
  const navigate = useNavigate()

  const goInternal = () => navigate(buttonUrl)
  const goExternal = () => window.open(buttonUrl)

  const onClickHandler = () => {
    if (buttonUrl === PathNames.KYB_SIGNUP_URL) {
      if (isSandbox || isTest) Amp.track(AmplitudeEvent.DEVX_SANDBOX_CLICKED_SIGN_UP)
      if (isProduction) Amp.track(AmplitudeEvent.DEVX_PROD_CLICKED_SIGN_UP)
      Amp.track(AmplitudeEvent.ONBOARDING_CLICK_SIGNUP_TOP_LINK, {
        category: AmplitudeEventCategory.SIGNUP,
        action: AmplitudeEventAction.CLICK,
      })

      window.location.href = `${process.env.ONBOARDING_URL}${buttonUrl}`
      return
    }
    externalLink ? goExternal() : goInternal()
  }

  return (
    <Container flex align="center" justify="end" className="flex-wrap pl-4">
      {helpText && (
        <span className="text-body-regular text-foreground-subdued py-2">{helpText}</span>
      )}
      <Box className={helpText ? 'ml-3' : ''}>
        <Button onClick={onClickHandler} variant="secondary">
          {buttonText}
        </Button>
      </Box>
    </Container>
  )
}
